import { createElement, ReactElement } from 'react';
import { useReactDndConstructs as useDragAndDropHooks } from '../../../../dnd/ReactDndContext';
import { TestIdProps } from '../../../../util/testId';
import { DragPreview } from '../../../../dnd/view/DragPreview';
import { renderInlineCssVars, useDesignTokens } from '../../../../theme';
import { getTabSpacingTokens } from '../TabToken';

export interface TabDragPreviewProps extends TestIdProps {
  children: (tabIndex: number) => ReactElement;
  dragType: string;
  dndPrefix: string;
}

export const TabDragPreview = (props: TabDragPreviewProps) => {
  const { useDragLayer } = useDragAndDropHooks();
  const { itemType, item } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
  }));

  const dt = useDesignTokens();
  const tabBarTokens = renderInlineCssVars(getTabSpacingTokens(dt), 'tab-bar');

  const renderItem = () => {
    if (!item || item.dndPrefix !== props.dndPrefix) return null;

    switch (itemType) {
      case props.dragType:
        return props.children(item.index);
      default:
        return null;
    }
  };

  return <DragPreview style={tabBarTokens}>{renderItem()}</DragPreview>;
};
